<!-- 产品列表 -->
<template>
  <div>
    <ul class="product-ul">
      <li
        class="product-one"
        v-for="(item, index) in viewsList"
        :key="index"
        @click="toProductDetail(item,index)"
      >
        <div class="product-div">
          <img
            class="product-img"
            :src="item.indexImg"
            alt
          />
        </div>
        <p class="product-p1">{{ item.classification }}</p>
        <p class="product-p fn-14">{{ item.model }}</p>
        <p class="product-p">{{ item.specifications }}</p>
        <el-button
          size="small"
          class="produuct-button"
        >立即查看</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 当前要展示的列表
      viewsList: [],
      arrName: "",
    };
  },

  components: {},
  created() {
    this.viewsList = this.$store.state.moduleSnap;
  },

  mounted() {
    let index = this.$route.params.index;
    if (index == "1-1") {
      this.arrName = "moduleSnap";
      this.viewsList = this.$store.state.moduleSnap;
    } else if (index == "2-1") {
      this.arrName = "EntranceGuard6100";
      this.viewsList = this.$store.state.EntranceGuard6100;
    } else if (index == "3-1") {
      this.arrName = "vidiconEconomic";
      this.viewsList = this.$store.state.vidiconEconomic;
    } else if (index == "6-1") {
      this.arrName = "shangHaiQiGan";
      this.viewsList = this.$store.state.shangHaiQiGan;
    }
  },

  methods: {
    toProductDetail(item, index) {
      // console.log(item, index);
      // return false;
      this.$router.push({
        path: "/productDetail",
        query: {
          detail: JSON.stringify({
            arrName: this.arrName,
            index: index,
          }),
        },
      });
    },
    // 控制当前展示的产品数组
    changeView(index) {
      switch (index) {
        case "1-1":
          this.arrName = "moduleSnap";
          this.viewsList = this.$store.state.moduleSnap;
          break;
        case "1-2":
          this.arrName = "moduleIdentify";
          this.viewsList = this.$store.state.moduleIdentify;
          break;
        case "1-3":
          this.arrName = "moduleMachineNonhuman";
          this.viewsList = this.$store.state.moduleMachineNonhuman;
          break;
        case "1-4":
          this.arrName = "cvitekebike";
          this.viewsList = this.$store.state.cvitekebike;
          break;  
        case "5-1":
          this.arrName = "moduleBinocular";
          // console.log("双目识别模组");
          this.viewsList = this.$store.state.moduleBinocular;
          break;
        case "5-2":
          this.arrName = "moduleMonocular";
          // console.log("单目人脸识别门禁模组");
          this.viewsList = this.$store.state.moduleMonocular;
          break;
        case "2-1":
          this.arrName = "EntranceGuard6100";
          this.viewsList = this.$store.state.EntranceGuard6100;
          break;
        case "2-2":
          this.arrName = "EntranceGuardD200";
          this.viewsList = this.$store.state.EntranceGuardD200;
          // console.log("D200系列");
          break;
        case "2-3":
          this.arrName = "EntranceGuardTOF";
          this.viewsList = this.$store.state.EntranceGuardTOF;
          // console.log("tof");
          break;
        case "2-4":
          this.arrName = "EntranceGuardM200";
          this.viewsList = this.$store.state.EntranceGuardM200;
          break;
        case "3-1":
          this.arrName = "vidiconEconomic";
          this.viewsList = this.$store.state.vidiconEconomic;
          break;
        case "3-2":
          this.arrName = "vidiconProfessional";
          this.viewsList = this.$store.state.vidiconProfessional;
          // console.log("专业型");
          break;
        case "3-3":
          this.arrName = "vidiconManCar";
          this.viewsList = this.$store.state.vidiconManCar;
          break;
        case "3-4":
          this.arrName = "vidiconMK68PACU";
          this.viewsList = this.$store.state.vidiconMK68PACU;
          // console.log("摄像机");
          break;
        case "3-5":
          this.arrName = "TemperatureScreening";
          this.viewsList = this.$store.state.TemperatureScreening;
          break;
        case "4-1":
          this.arrName = "EntranceGuardZd500Thermomery";
          // zd500测温门禁
          this.viewsList = this.$store.state.EntranceGuardZd500Thermomery;

          break;
        case "4-6":
          // zd500识别门禁
          this.arrName = "EntranceGuardZD500";
          this.viewsList = this.$store.state.EntranceGuardZD500;
          break;
        case "4-2":
          this.arrName = "EntranceGuardMonocular";
          // console.log("单目人脸识别门禁");
          this.viewsList = this.$store.state.EntranceGuardMonocular;
          break;
        case "4-3":
          this.arrName = "EntranceGuardBinocular7";
          // console.log("双目人脸识别门禁");
          this.viewsList = this.$store.state.EntranceGuardBinocular7;
          break;
        case "4-7":
          this.arrName = "EntranceGuardBinocular8";
          this.viewsList = this.$store.state.EntranceGuardBinocular8;
          break;
        case "4-4":
          this.arrName = "EntranceGuardThermometryMonocular";
          // console.log("经济型测温门禁");
          this.viewsList = this.$store.state.EntranceGuardThermometryMonocular;
          break;
        case "4-5":
          this.arrName = "EntranceGuardThermometryBinocular7";
          this.viewsList = this.$store.state.EntranceGuardThermometryBinocular7;
          break;
        case "4-8":
          this.arrName = "EntranceGuardThermometryBinocular8";
          this.viewsList = this.$store.state.EntranceGuardThermometryBinocular8;
          break;
        case "3-5":
          this.arrName = "vidiconAttendance";
          this.viewsList = this.$store.state.vidiconAttendance;
          break;
        case "6-1":
          this.arrName = "shangHaiQiGan";
          this.viewsList = this.$store.state.shangHaiQiGan;
          break;
        case "6-2":
          this.arrName = "xiaMenXinChen";
          this.viewsList = this.$store.state.xiaMenXinChen;
          break;
        case "6-3":
          this.arrName = "haiSi";
          this.viewsList = this.$store.state.haiSi;
          break;
      }
    },
  },
};
</script>
<style >
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.product-ul {
  display: flex;
  flex-wrap: wrap;
}
.product-one {
  width: 45%;
  margin: 0 2% 2% 0;

  background: #fff;
}
.product-one:hover {
  box-shadow: 2px 2px 6px #c6c1c1;
}

.product-one:hover img {
  transform: scale3d(1.05, 1.05, 1.05);
  -ms-transform: scale3d(1.05, 1.05, 1.05);
  -moz-transform: scale3d(1.05, 1.05, 1.05);
  -webkit-transform: scale3d(1.05, 1.05, 1.05);
  -o-transform: scale3d(1.05, 1.05, 1.05);
}

.product-div {
  border-bottom: 1px solid #dcdcdc;
  overflow: hidden;
}
.product-img {
  width: 100%;
  -webkit-object-fit: cover;
  object-fit: cover;
  transition: 0.4s all linear;
  -ms-transition: 0.4s all linear; /* IE 9 */
  -moz-transition: 0.4s all linear; /* Firefox */
  -webkit-transition: 0.4s all linear; /* Safari 和 Chrome */
  -o-transition: 0.4s all linear; /* Opera */
}
.product-p1 {
  margin: 10px;
  font-size: 16px;
  color: #000;
  font-weight: 600;
  cursor: default;
}
.product-p {
  font-size: 12px;
  color: #686868;
  margin: 10px;
  height: 30px;
  cursor: default;
}
.produuct-button {
  background: #27bdff;
  font-size: 11px;
  color: #fff;
  margin: 10px;
  border: none;
  border-radius: 2px;
  float: right;
}
.produuct-button:hover {
  color: #fff;
  background: #27bdff;
  border: none;
}
.produuct-button:active {
  color: #fff;
  background: #27bdff;
  border: 1px solid #fff;
}
.el-menu-item.is-active {
  color: #27bdff;
}
.fn-14 {
  font-size: 14px;
}
</style>